/**
 * The class-name helper the shadcn components and the rest of the app
 * share. Kept at this path because shadcn generates against it.
 *
 * Used by: some eighty files, every shadcn component in src/components/ui
 * among them (components.json points shadcn's "utils" alias here).
 *
 * @module lib/utils
 */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind class names, with later classes winning conflicts.
 *
 * The single home for this. There were three identical copies —
 * src/lib/utils.ts, src/shared/lib/utils.ts and src/shared/utils/cn.ts — split
 * across twenty-seven files, so a change to class merging had to be made three
 * times or not at all. This path is the one shadcn generates its components
 * against, so it is the one that survives.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
